<template>
  <mdb-dropdown multi-level>
    <mdb-btn
      slot="toggle"
      icon="sign-in-alt"
      size="sm"
      rounded
      color="lightblue"
      title="Log In"
      @click="active = 0"
    />
    <mdb-dropdown-menu dropleft class="h-100">
      <mdb-tabs
        @click.native.stop
        :active="active"
        @activeTab="active = $event"
        card
        color="cyan"
        :links="[
          { text: 'Sign In', slot: 'sign-in'},
          { text: 'Sign Up', slot: 'sign-up'}
        ]"
        :transition-duration="0"
        transition-style="linear"
      >
        <template :slot="'sign-in'">
          <form class="px-2 py-2 h-100" @submit.stop>
            <div class="form-group">
              <mdb-input
                id="login-username-input"
                name="login-username"
                label="Username"
                v-model="username"
                outline
                @click.native.stop
              />
            </div>
            <div class="form-group">
              <mdb-input
                type="password"
                id="login-password-input"
                name="login-password"
                label="Password"
                v-model="password"
                outline
                @click.native.stop
              />
            </div>
            <mdb-btn
              @click="login"
              type="button"
              size="sm"
              rounded
              gradient="aqua"
              class="float-right"
              title="Log in"
            >Sign in</mdb-btn>
          </form>
        </template>
        <template :slot="'sign-up'">
          <form class="px-2 py-2" @submit.stop>
            <div class="form-group">
              <mdb-input
                id="register-username-input"
                name="register-username"
                label="Username"
                v-model="username"
                outline
                @click.native.stop
              />
            </div>
            <div class="form-group">
              <mdb-input
                type="email"
                id="register-email-input"
                name="register-email"
                label="Email"
                v-model="email"
                outline
                @click.native.stop
              />
            </div>
            <div class="form-group">
              <mdb-input
                type="password"
                id="register-password-input"
                name="register-password"
                label="Password"
                v-model="password"
                outline
                @click.native.stop
              />
            </div>
            <mdb-btn
              @click="register"
              type="button"
              size="sm"
              rounded
              gradient="aqua"
              class="float-right"
              title="Register"
            >Register</mdb-btn>
          </form>
        </template>
      </mdb-tabs>
    </mdb-dropdown-menu>
  </mdb-dropdown>
</template>

<script>
import {
  mdbDropdown,
  mdbDropdownToggle,
  mdbDropdownMenu,
  mdbIcon,
  mdbBtn,
  mdbInput,
  mdbTabs
} from 'mdbvue'
import { mapActions } from 'vuex'
import {errorCatch} from '../utils'

export default {
  name: 'HeaderDropdownLogin',
  data () {
    return {
      username: null,
      email: null,
      password: null,
      active: null
    }
  },
  methods: {
    ...mapActions('user', ['authRequest', 'registerRequest']),
    login () {
      const {username, password} = this
      this.authRequest({name: username, password: password})
        .then(() => this.$bus.$emit('profile-fetch-completed'))
        .catch(error => {
          const status = error.response && error.response.status
          if (status === 401) {
            this.$notify.warn({
              title: 'Auth failed.',
              message: 'Wrong Credentials',
              position: 'top right',
              closeButton: true
            })
          } else {
            this.$notify.error({
              title: 'Login failed',
              message: error.response.data,
              position: 'top right',
              closeButton: true
            })
          }
        })
    },
    register () {
      const {username, email, password} = this
      const re = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
      if (!re.test(String(email).toLowerCase())) {
        this.$notify.warn({
          title: 'Wrong email.',
          message: '',
          position: 'top right',
          timeOut: 10000,
          closeButton: true
        })
        return
      }
      this.registerRequest({name: username, email: email, password: password})
        .then(() => {
          this.active = 0
          this.$notify.success({
            title: 'Registration successful.',
            message: 'Use your credentials to log in',
            position: 'top right',
            timeOut: 3000,
            closeButton: true
          })
        })
        .catch(errorCatch('Registration failed', this))
    }
  },
  components: {
    mdbDropdown,
    mdbDropdownToggle,
    mdbDropdownMenu,
    mdbIcon,
    mdbBtn,
    mdbInput,
    mdbTabs
  }
}
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/components/HeaderDropdownLogin.vue